"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindActiveContract = void 0;
const store_1 = require("@app/store");
const useSortedContracts_1 = require("@app/util/hooks/useSortedContracts");
const react_1 = __importDefault(require("react"));
const useFindActiveContract = () => {
    const employees = (0, store_1.useRootSelector)((state) => Object.values(state.employees).filter((emp) => !emp.external));
    const findActiveContract = react_1.default.useCallback((userId, periodStart) => {
        const selectedEmployee = employees.find((emp) => emp.id === userId);
        const { activeContracts } = (0, useSortedContracts_1.parseContracts)(selectedEmployee?.contracts ?? [], periodStart);
        const activeContract = activeContracts.find((c) => c.type === selectedEmployee?.contractType);
        return activeContract;
    }, [employees]);
    return findActiveContract;
};
exports.useFindActiveContract = useFindActiveContract;
